module.exports = __webpack_public_path__ + "img/kefuicon.ac0b90ea.png";